import { render, staticRenderFns } from "./ReportsStatistics.vue?vue&type=template&id=676467e8&scoped=true&"
import script from "./ReportsStatistics.vue?vue&type=script&lang=js&"
export * from "./ReportsStatistics.vue?vue&type=script&lang=js&"
import style0 from "./ReportsStatistics.vue?vue&type=style&index=0&id=676467e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676467e8",
  null
  
)

export default component.exports